







import { Component, Prop, Vue } from 'vue-property-decorator';
import { IDiscordProfile } from '~/store/profile/types';

@Component({})
export default class DiscordProfileBadge extends Vue {
  @Prop(Object) readonly discordProfile!: IDiscordProfile;

  emptyLogo = require('@/assets/logos/discord-empty-profile.png');

  get profileImage() {
    return this.discordProfile?.avatar
      ? `https://cdn.discordapp.com/avatars/${this.discordProfile?.id}/${this.discordProfile?.avatar}.png`
      : this.emptyLogo;
  }
}
